
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_umbhe_1k0eu_1",
  "active": "awsui_active_umbhe_1k0eu_9"
};
  